export enum ValidationType {
  Validated = 1,
  Pending,
  Rejected
}
